/* with love from shopstory */
var index = require('./index-0b475274.js');
var React = require('react');
require('@stitches/core');
require('lodash.curry');
require('crypto-js');
require('styled-components');
require('react-dom');
require('lodash.debounce');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

React__default["default"].createElement;
var VIMEO_URL = "https://vimeo.com/";
function VimeoPlayerInternal(_ref) {
  var __fromEditor = _ref.__fromEditor;

  var _useState = React.useState(false),
      canPlayerBeLoaded = _useState[0],
      setCanPlayerBeLoaded = _useState[1];

  var playerLoadingStatusRef = React.useRef("not_loaded");

  var _useState2 = React.useState(null),
      errorMessage = _useState2[0],
      setErrorMessage = _useState2[1];

  var embeddedPlayerContainerRef = React.useRef(null);
  var playerInstanceRef = React.useRef(null);
  var _fromEditor$props = __fromEditor.props,
      areControlsDisabled = _fromEditor$props.areControlsDisabled,
      isAutoPlay = _fromEditor$props.isAutoPlay,
      isLoop = _fromEditor$props.isLoop,
      isMuted = _fromEditor$props.isMuted,
      videoId = _fromEditor$props.videoId;
  var _fromEditor$componen = __fromEditor.components,
      AspectRatioMaker = _fromEditor$componen.AspectRatioMaker,
      ErrorContainer = _fromEditor$componen.ErrorContainer,
      ContentWrapper = _fromEditor$componen.ContentWrapper,
      Placeholder = _fromEditor$componen.Placeholder,
      PlayerContainer = _fromEditor$componen.PlayerContainer,
      Wrapper = _fromEditor$componen.Wrapper;

  function initVimeoPlayer() {
    return _initVimeoPlayer.apply(this, arguments);
  }

  function _initVimeoPlayer() {
    _initVimeoPlayer = index._asyncToGenerator( /*#__PURE__*/index.regenerator.mark(function _callee2() {
      var Player, url;
      return index.regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return loadVimeoPlayer();

            case 2:
              Player = _context2.sent;
              url = "".concat(VIMEO_URL).concat(videoId);
              playerInstanceRef.current = new Player(embeddedPlayerContainerRef.current, {
                url: url,
                responsive: true,
                autoplay: isAutoPlay,
                loop: isLoop,
                controls: !areControlsDisabled,
                muted: isMuted,
                portrait: false,
                title: false,
                byline: false
              });
              playerInstanceRef.current.ready().then(function () {
                playerLoadingStatusRef.current = "loaded";
                setErrorMessage(null);
              })["catch"](function () {
                playerLoadingStatusRef.current = "error";
                setErrorMessage("Error during loading the video. Make sure given ID is correct and the video is available.");
              });
              playerInstanceRef.current.on("error", function (error) {
              });

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _initVimeoPlayer.apply(this, arguments);
  }

  React.useEffect(function enablePlayerLoadingWhenIdleOrInViewport() {
    if (canPlayerBeLoaded) {
      return;
    }

    var idleCallbackRequestId;
    var intersectionObserver;
    var isRequestIdleCallbackSupported = ("requestIdleCallback" in window);

    function idleCallback() {
      var _intersectionObserver;

      if (canPlayerBeLoaded) {
        return;
      }

      setCanPlayerBeLoaded(true);
      (_intersectionObserver = intersectionObserver) === null || _intersectionObserver === void 0 ? void 0 : _intersectionObserver.disconnect();
    }

    function cancelIdleCallback() {
      if (idleCallbackRequestId) {
        if (isRequestIdleCallbackSupported) {
          window.cancelIdleCallback(idleCallbackRequestId);
        } else {
          clearTimeout(idleCallbackRequestId);
        }
      }
    }

    if (videoId && !playerInstanceRef.current && embeddedPlayerContainerRef.current) {
      idleCallbackRequestId = isRequestIdleCallbackSupported ? window.requestIdleCallback(idleCallback, {
        timeout: 2000
      }) : window.setTimeout(idleCallback, 0);
      intersectionObserver = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          setCanPlayerBeLoaded(true);
          cancelIdleCallback();
        }
      }, {
        threshold: 0.5
      });
      intersectionObserver.observe(embeddedPlayerContainerRef.current);
    }

    return function () {
      var _intersectionObserver2;

      cancelIdleCallback();
      (_intersectionObserver2 = intersectionObserver) === null || _intersectionObserver2 === void 0 ? void 0 : _intersectionObserver2.disconnect();
    };
  }, [videoId, canPlayerBeLoaded]);
  React.useEffect(function () {
    if (playerLoadingStatusRef.current === "loaded") {
      initVimeoPlayer();
    }
  }, [areControlsDisabled, isAutoPlay]);
  React.useEffect(function () {
    var playerLoadingStatus = playerLoadingStatusRef.current;

    function loadVideoById(_x) {
      return _loadVideoById.apply(this, arguments);
    }

    function _loadVideoById() {
      _loadVideoById = index._asyncToGenerator( /*#__PURE__*/index.regenerator.mark(function _callee(videoId) {
        var _playerInstanceRef$cu4;

        return index.regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return (_playerInstanceRef$cu4 = playerInstanceRef.current) === null || _playerInstanceRef$cu4 === void 0 ? void 0 : _playerInstanceRef$cu4.loadVideo(Number(videoId));

              case 3:
                playerLoadingStatusRef.current = "loaded";

                if (errorMessage !== null) {
                  setErrorMessage(null);
                }

                _context.next = 11;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                playerLoadingStatusRef.current = "error";
                setErrorMessage("Error during loading the video. Make sure given ID is correct and the video is available.");

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }));
      return _loadVideoById.apply(this, arguments);
    }

    if (canPlayerBeLoaded) {
      if (playerLoadingStatus === "loaded") {
        if (videoId === "") {
          var _playerInstanceRef$cu;

          (_playerInstanceRef$cu = playerInstanceRef.current) === null || _playerInstanceRef$cu === void 0 ? void 0 : _playerInstanceRef$cu.destroy();
          playerLoadingStatusRef.current = "not_loaded";
        } else {
          loadVideoById(videoId);
        }
      } else if (playerLoadingStatus === "error" || playerLoadingStatus === "not_loaded") {
        if (videoId === "" && playerLoadingStatus === "error") {
          var _playerInstanceRef$cu2;

          (_playerInstanceRef$cu2 = playerInstanceRef.current) === null || _playerInstanceRef$cu2 === void 0 ? void 0 : _playerInstanceRef$cu2.destroy();
        } else if (videoId !== "") {
          var _playerInstanceRef$cu3;

          (_playerInstanceRef$cu3 = playerInstanceRef.current) === null || _playerInstanceRef$cu3 === void 0 ? void 0 : _playerInstanceRef$cu3.destroy();
          initVimeoPlayer();
        }

        setErrorMessage(null);
      }
    }
  }, [videoId, canPlayerBeLoaded]);
  React.useEffect(function () {
    var _playerInstanceRef$cu5;

    (_playerInstanceRef$cu5 = playerInstanceRef.current) === null || _playerInstanceRef$cu5 === void 0 ? void 0 : _playerInstanceRef$cu5.setMuted(isMuted);
  }, [isMuted]);
  React.useEffect(function () {
    var _playerInstanceRef$cu6;

    (_playerInstanceRef$cu6 = playerInstanceRef.current) === null || _playerInstanceRef$cu6 === void 0 ? void 0 : _playerInstanceRef$cu6.setLoop(isLoop);
  }, [isLoop]);
  return index.createElement(Wrapper, null, index.createElement(AspectRatioMaker, null), index.createElement(ContentWrapper, null, videoId ? index.createElement(React.Fragment, null, index.createElement(PlayerContainer, {
    ref: embeddedPlayerContainerRef
  }), errorMessage && index.createElement(ErrorContainer, null, errorMessage)) : index.createElement(Placeholder, null)));
}

function loadVimeoPlayer() {
  return _loadVimeoPlayer.apply(this, arguments);
}

function _loadVimeoPlayer() {
  _loadVimeoPlayer = index._asyncToGenerator( /*#__PURE__*/index.regenerator.mark(function _callee3() {
    var _yield$import, Player;

    return index.regenerator.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return Promise.resolve().then(function () { return /*#__PURE__*/_interopNamespace(require('@vimeo/player')); });

          case 2:
            _yield$import = _context3.sent;
            Player = _yield$import["default"];
            return _context3.abrupt("return", Player);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _loadVimeoPlayer.apply(this, arguments);
}

exports.VimeoPlayerInternal = VimeoPlayerInternal;
